export function getFirstName(name: string | null | undefined, fallback: string): string {
  const candidate = name?.split(" ")[0]?.trim() || fallback;
  return candidate;
}
